import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import el from './locales/el.json'

const savedLang = localStorage.getItem('lang') || 'el'

export const i18n = createI18n({
    legacy: false,
    locale: savedLang,
    fallbackLocale: 'el',
    messages: {
        en,
        el
    }
})
